// GraphQL queries for Billing Cycles (proxy membership API)

export const listBillingCyclesQuery = `
  query ListBillingCycles($input: ListBillingCyclesInput) {
    listBillingCycles(input: $input) {
      code
      billingCycleList {
        billingCycleId
        code
        label
        durationValue
        durationUnit
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;

export const getBillingCycleQuery = `
  query GetBillingCycle($input: GetBillingCycleInput!) {
    getBillingCycle(input: $input) {
      code
      billingCycle {
        billingCycleId
        code
        label
        durationValue
        durationUnit
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;
